<div class="sales-order-status-tab--container mt-14">
  <ng-container *ngIf="!loading; else skeleton">
    <mat-nav-list>
      <mat-list-item
        *ngFor="let status of data; let i = index; trackBy: trackByValue"
        (click)="onSetStatus(status.orderStatus)"
        [class.active]="status.orderStatus === activeFilter"
      >
        <span class="item-title flex align-items-center" matListItemTitle>
          <lum-ui-icon
            class="mr-2-5"
            icon="chevron-right"
            color="#54555a"
            width="16"
            height="16"
          ></lum-ui-icon>
          {{ status.orderStatus | orderStatusLabel }}
        </span>

        <div *ngIf="status.orderStatusCount" class="item-badge">
          {{ status.orderStatusCount | numberFormat }}
        </div>
      </mat-list-item>
    </mat-nav-list>
  </ng-container>
  <ng-template #skeleton>
    <div class="skeleton">
      <div class="skeleton-item" *ngFor="let item of skeletonItems">
        <span> </span>
      </div>
    </div>
  </ng-template>
</div>
